import { defineStore } from "pinia";

export const useMenuStore = defineStore("menu", {
  state: () => ({
    isMainMenuOpen: false,
    isMobileMenuOpen: false,
  }),
  actions: {
    toggleMainMenu() {
      this.isMainMenuOpen = !this.isMainMenuOpen;
    },
    openMainMenu() {
      this.isMainMenuOpen = true;
    },
    closeMainMenu() {
      this.isMainMenuOpen = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    openMobileMenu() {
      this.isMobileMenuOpen = true;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
  },
});
